module.exports = __webpack_public_path__ + "img/defaultVoucherIco.67a39cae.png";